import React from "react"
import { graphql } from "gatsby"

import SEO from "../components/seo"
import Navigator from "../components/navigator/DefaultNavbar";
import Header from "../components/headers/blogPostDetails/Header";
import Footer from "../components/footer/DefaultFooter";
import CookieConsent from "../components/cookieConsent/CookieConsent";
import BlogPostDetails from "../components/blogPostDetails/BlogPosts";

const BlogPostTemplate = ({ data }) => {
  const post = data.markdownRemark
  const { previous, next } = data

    return (
        <>
            <SEO
                title={post.frontmatter.title}
                description={post.frontmatter.description || post.excerpt} />
            <Navigator
                useSpaNav={true}
            />
            <Header
                big={false}
                title={post.frontmatter.title}>
                <div className="blog-post-date">{post.frontmatter.date} - 8 MIN READ</div>
            </Header>

            <BlogPostDetails post={post} next={next} previous={previous} />

            <div style={{ marginTop: 200, }}>
                <Footer />
            </div>
            <CookieConsent />
        </>
    )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug(
    $id: String
    $previousPostId: String
    $nextPostId: String
  ) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        image
        category
      }
    }
    previous: markdownRemark(id: { eq: $previousPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
    next: markdownRemark(id: { eq: $nextPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
  }
`
